import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Auth from '@aws-amplify/auth';
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Label,
  Loader,
  Segment,
} from 'semantic-ui-react';
import clone from 'clone';
import { push } from 'react-router-redux';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import NavBar from '../../components/NavBar';
import Timestamp from '../../components/Timestamp';
import Identity from '../../components/Identity';
import FormGroup from '../../components/FormGroup';

export default class MultipleEntity extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
      creditCheckID: PropTypes.string,
    }),
  }
  static defaultCustomerData = {
    id: '',
    customerDetailID: '',
    identityTypeID: '',
    identity: '',
    icFrontDocumentID: '',
    icFrontDocument: null,
    icBackDocumentID: '',
    icBackDocument: null,
    incomeID: '',
    customerCreditReport: null,
    customerCreditReports: [],
    runCreditCheck: false,
  }
  static defaultCustomerCreditReport = {
    id: '',
    multiEntityKey: '',
    createdAt: '',
    updatedAt: '',
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const customer = Object.assign({}, MultipleEntity.defaultCustomerData, props.data || {});
    if (!customer.customerDetailID) {
      customer.customerDetail = Object.assign({}, MultipleEntity.defaultCustomerDetailData);
    }
    if (!customer.customerCreditReportID) {
      customer.customerCreditReport = Object.assign({}, MultipleEntity.defaultCustomerCreditReport);
    }
    return {
      customer,
      oriData: clone(customer),
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = MultipleEntity.getPropsToState(props);
    this.state = {
      ...state,
      token: null,
      data: [],
      selectedEntity: null,
    };
  }

  componentDidMount() {
    const { store } = this.context;
    this.setLoading(true)
      .then(() => {
        const promises = [
          this.fetchCreditReport(),
        ];
        return Promise.all(promises)
          .catch((err) => {
            Bugsnag.notifyException(err);
            store.dispatch(flashErrorMessage(err));
          });
      })
      .then(() => this.setLoading(false));
  }

  componentWillReceiveProps(nextProps) {
    const state = MultipleEntity.getPropsToState(nextProps);
    this.setState({ ...state });
  }

  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchCreditReport() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/customers/${this.props.params.id}/credit_reports/${this.props.params.creditCheckID}/multiple_entities/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      await this.setComponentState({
        token,
        data,
        oriData: clone(data),
      });
    }
  }
  submitable() {
    return this.state.selectedEntity;
  }
  handleOnChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleOnClick(event, value) {
    event.preventDefault();
    const selectedEntity = value;
    this.setState({
      selectedEntity,
    });
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    await this.setLoading(true);
    const { store } = this.context;
    const { customer, selectedEntity, token } = this.state;
    const creditReport = customer.customerCreditReport;
    creditReport.multiEntityKey = selectedEntity;

    let res;
    try {
      const jwtToken = (await Auth.currentSession()).getAccessToken().getJwtToken();
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/customers/${this.props.params.id}/credit_reports/${this.props.params.creditCheckID}/multiple_entities/confirm_entity/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
          'X-JWT-Token': jwtToken,
        },
        body: JSON.stringify(creditReport),
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const d = await res.json();
    customer.customerCreditReport = d;
    await this.setComponentState({
      customer,
    });
    await this.setLoading(false);
    store.dispatch(push('/customers/manage/credit_checks/'));
    store.dispatch(flashSuccessMessage({ header: 'Entity selected', message: `${customer.customerCreditReport.name}'s report is pending.` }));
  }
  render() {
    const { loading, customer, data, selectedEntity } = this.state;
    return (
      <Container>
        <NavBar
          header={data !== undefined && data.length > 0 ?
            <span>Multiple records &nbsp;<Label color="blue">{data.length }</Label></span> :
            'Multiple records'
          }
        />
        <Grid className="manage credit-check">
          <Grid.Row>
            <Grid.Column>
              <Dimmer
                active={loading &&
                  data &&
                  data.length > 0
                }
                inverted
              >
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              <Segment className="dark credit-check" style={{ background: '#383f44', padding: 0 }} inverted secondary textAlign="center">
                {
                  customer.customerCreditReport.multiEntityKey !== '' ?
                    <p>{`${customer.customerCreditReport.name}'s report is selected.`}</p> :
                    <form className="DSRMultipleRecords" onSubmit={this.handleSubmit}>
                      <div className="status-content">
                        <div className="title">
                          <div>
                            <h1>Multiple records</h1>
                          </div>
                          <div>
                            <p className="date">Submitted: <Timestamp timestamp={customer.customerCreditReport.createdAt} /></p>
                          </div>
                        </div>
                      </div>
                      <div className="content">
                        <h5>Oops ...</h5>
                        <p>Bank Negara / CTOS has { data !== undefined && data.length > 0 ? data.length : '...' } <span style={{ whiteSpace: 'nowrap' }}>records for</span></p>
                        <p>{customer.customerDetail.name}</p>
                        <br />
                        <p>Please select one to proceed.</p>
                        <table>
                          <thead>
                            <tr>
                              <th />
                              <th>Name</th>
                              <th>Ic</th>
                              <th>Nationality</th>
                              <th>Dob</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              !loading &&
                              data &&
                              data.map((details, idx) => (
                                <tr
                                  onClick={e => this.handleOnClick(e, details.entityKey)}
                                  className={
                                    selectedEntity === details.entityKey ?
                                    'selected' : null
                                    }
                                  key={idx}
                                >
                                  <td>
                                    <div className="tag">
                                      <FormGroup>
                                        <input
                                          id={`select-${details.entityKey}`}
                                          type="radio"
                                          value={details.entityKey}
                                          name="selectedEntity"
                                          checked={selectedEntity === details.entityKey}
                                          onChange={this.handleOnChange}
                                        />
                                        <label
                                          htmlFor={`select-${details.entityKey}`}
                                        >
                                          &nbsp;
                                        </label>
                                      </FormGroup>
                                      <span>{ idx + 1 }</span>
                                    </div>
                                  </td>
                                  <td>
                                    {
                                      details.idNo1 &&
                                      <div
                                        style={{
                                          whiteSpace: 'nowrap',
                                          marginBottom: '0.5em',
                                        }}
                                      >
                                        NEW:<br /><Identity type={1} identity={details.idNo1} />
                                      </div>
                                    }
                                    {
                                      details.idNo2 &&
                                      <div
                                        style={{
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        OLD:<br />{ details.idNo2 }
                                      </div>
                                    }
                                  </td>
                                  <td>{ details.name }</td>
                                  <td>{ details.nationality }</td>
                                  <td>{ details.birthDate }</td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                      <div className="mobile-center">
                        <Button
                          loading={loading}
                          disabled={!this.submitable()}
                        >
                          Confirm Selection
                        </Button>
                      </div>
                    </form>
                }
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/MultipleEntity.jsx